import { createSlice } from '@reduxjs/toolkit'

interface DiscountState {
  isDiscounted: boolean
}

const initialState: DiscountState = {
  isDiscounted: false,
}

const discountSlice = createSlice({
  name: 'discount',
  initialState,
  reducers: {
    setIsDiscounted: (state, action) => {
      state.isDiscounted = action.payload
    },
  },
})

export const { setIsDiscounted } = discountSlice.actions
export default discountSlice.reducer